export const types=({
    authCheckinInit:            '[auth] Init cheking after login',
    authCheckinFinish:          '[auth] Finish cheking login state',
    authStartLogin:             '[auth] Start login',
    authLogin:                  '[auth] Login',
    authStartTokenRenew:        '[auth] Start token renew',
    authLogout:                 '[auth] Logout',
    authSetType:                '[auth] Change the type',
    authSetUsername:            '[auth] Set the username',

    clientLoading:              '[client] Loading client',
    clientLogout:               '[client] Logout',
    clientAddingRoom:           '[client] Adding Room',
    clientFinishRedes:          '[client] Finish Redes',

    eventsAdd:                   '[event] Add events',

    paymentsloading:            '[payments] Loading payments',
    paymentsStartLoading:       '[payments] On the loading flag',
    paymentsFinishLoading:      '[payments] Off the loading flag',
    paymentsAddPayment:         '[payments] Add a new payment',
    paymentsAddTotal:           '[payments] Add to the total',
    paymentsLogout:             '[payments] Logout',

    formsValidStart:            '[formValid] Start form valid',
    formsValidFinish:           '[formValid] Finish form valid',
    formsValidError:            '[formValid] Error form valid',
    formsValidMsg:              '[formValid] Mesage form valid',
    formsValidDestroy:          '[formValid] destroy form validation',


    roomsLoadingList:           '[room] Start loading parners',
    roomsDeleteFolio:           '[room] Start Deleting a parner',
    roomsAddFolio:              '[room] Start Adding a parner',
    
    modalStartLoadingCliente:   '[modal] Start loading data cliente',
    modalSetData:               '[modal] Set data in redux',
    modalFinishLoadingCliente:  '[modal] Finish loading data cliente',
    modalCleaning:              '[modal] Clean data for modal'
})